import { render, staticRenderFns } from "./SwabSamplesResultsTable.vue?vue&type=template&id=0599b564&scoped=true&"
import script from "./SwabSamplesResultsTable.vue?vue&type=script&lang=ts&"
export * from "./SwabSamplesResultsTable.vue?vue&type=script&lang=ts&"
import style0 from "./SwabSamplesResultsTable.vue?vue&type=style&index=0&id=0599b564&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0599b564",
  null
  
)

export default component.exports